import { useTheme } from "@mui/material";
import { Selector} from '../../../../../../Selector'

export const CurrensySelector= ({
  tokens,
  selectedToken,
  onChangeToken,
  disabled,
}) => {	
  const theme = useTheme();

  const handleChangeToken = (symbol) => {
    const token = tokens.find((tokens) => tokens.symbol === symbol);

    if (token) {
      onChangeToken(token);
    }
  };

  return (
    <Selector
      isShowIcons
      disabled={disabled}
      handleChangeRole={handleChangeToken}
      active={tokens.find(
        (el) => el.symbol.toLowerCase() === selectedToken?.symbol.toLowerCase()
      )}
      options={tokens.filter(
        (el) => el.symbol.toLowerCase() !== selectedToken?.symbol.toLowerCase()
      )}
      width={{ xs: "74px", sm: "115px" }}
      styles={{
        backgroundColor: theme.palette.mode === "light" ? "#FFFFFF" : "#22246A",
        color: theme.palette.text.primary,
        border: "1px solid transparent",
        gap: { xs: "12px", sm: "24px" },
        boxSizing: "border-box",
      }}
    />
  );
};
